import { Component, Input } from '@angular/core';
import { Station } from '../../../../../../models/stations.model';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
})
export class WelcomeComponent {
  @Input() station: Station | undefined;
  @Input() track: number | undefined;
  @Input() notifications: string[];
  @Input() switchTime: number | undefined;
}
